var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "btn p-8-12 btn__up-down btn--sm-scr btn-modal-upload",
          attrs: {
            type: "button",
            "data-testid": "batch-upload-button",
            disabled: _vm.isDisable
          },
          on: { click: _vm.handleBatchUploadButtonClick }
        },
        [
          _c("img", {
            staticClass: "mr-8",
            attrs: { src: require("@static/img/upload.svg"), alt: "upload" }
          }),
          _vm._v(" Batch Upload ")
        ]
      ),
      _c(
        "Dialog",
        {
          attrs: {
            isOpen: _vm.isModalOpen,
            title: _vm.getDisplayText(
              "payPoPage_payPO_componentBatchUpload_modalTitle"
            )
          },
          on: {
            "update:isOpen": function($event) {
              _vm.isModalOpen = $event
            },
            "update:is-open": function($event) {
              _vm.isModalOpen = $event
            }
          }
        },
        [
          _vm.error
            ? _c("ep-alert", { attrs: { "data-testid": "alert" } }, [
                _vm._v(" " + _vm._s(_vm.error) + " ")
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "d-flex flex-column align-items-center mt-5" },
            [
              _vm.fileName
                ? _c("div", { staticClass: "d-flex align-items-center" }, [
                    _c("img", {
                      staticClass: "mr-2",
                      attrs: {
                        "data-testid": "file-icon",
                        src: require("@static/img/copy.svg"),
                        alt: "File"
                      }
                    }),
                    _c("div", { attrs: { "data-testid": "filename-text" } }, [
                      _vm._v(_vm._s(_vm.fileName))
                    ])
                  ])
                : _c(
                    "h4",
                    {
                      staticClass: "font-weight-bold",
                      attrs: { "data-testid": "choose-file-text" }
                    },
                    [_vm._v("Choose a file you want to upload")]
                  ),
              _c(
                "div",
                { staticClass: "mt-4" },
                [
                  _c(
                    "ep-button",
                    {
                      staticClass: "select-file-button",
                      attrs: {
                        state: _vm.state === "error" ? "default" : _vm.state,
                        "data-testid": "select-file-button"
                      },
                      on: { click: _vm.handleFileButtonClick }
                    },
                    [_vm._v(" Select File ")]
                  ),
                  _c("input", {
                    ref: "fileInput",
                    staticClass: "d-none",
                    attrs: {
                      type: "file",
                      accept: ".xlsx, .xls",
                      "data-testid": "select-file-input"
                    },
                    on: { change: _vm.handleFileSelect }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "mt-3",
                  attrs: { "data-testid": "maximum-file-size-text" }
                },
                [_vm._v("Maximum file size: 300KB")]
              ),
              _c("div", { attrs: { "data-testid": "file-format-text" } }, [
                _vm._v("File format: XLSX or XLS")
              ]),
              _c(
                "div",
                {
                  staticClass: "overwritten-alert",
                  attrs: { "data-testid": "overwritten-alert" }
                },
                [
                  _c("error-icon"),
                  _vm._v(" Your data inputted will be overwritten ")
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }